import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "mobile-home"
};
import { ref, watch } from "vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'Home',
  setup(__props) {
    const active = ref('home');
    const store = useSharedStore();
    const theme = ref(store.theme);
    watch(() => store.theme, val => {
      theme.value = val;
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        theme: theme.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view), _createVNode(_component_van_tabbar, {
          route: "",
          modelValue: active.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
            to: "/mobile/index",
            name: "home",
            icon: "home-o"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("首页")])),
            _: 1
          }), _createVNode(_component_van_tabbar_item, {
            to: "/mobile/chat",
            name: "chat",
            icon: "chat-o"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("对话")])),
            _: 1
          }), _createVNode(_component_van_tabbar_item, {
            to: "/mobile/image",
            name: "image",
            icon: "photo-o"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("绘图")])),
            _: 1
          }), _createVNode(_component_van_tabbar_item, {
            to: "/mobile/profile",
            name: "profile",
            icon: "user-o"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("我的 ")])),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])])]),
        _: 1
      }, 8, ["theme"]);
    };
  }
};